<template>
	<div>
		<p class="font-medium text-gray-700" v-if="showLabel">{{ __("Price") }}</p>

		<div class="flex flex-col sm:flex-row flex-wrap gap-x-6 gap-y-3 mt-1">
			<ui-radio-group
				v-if="form.trade == 'SELL' && !isPriceRequired"
				v-model="priceType"
				name="priceType"
				radioValue="NONE"
				:key="'null-' + priceType"
				label="Without Price"
			></ui-radio-group>
			<ui-radio-group
				v-model="priceType"
				name="priceType"
				radioValue="FLAT"
				:key="'true-' + priceType"
				label="Flat Price"
			></ui-radio-group>
			<ui-radio-group
				name="priceType"
				v-model="priceType"
				radioValue="INDEXED"
				:key="'false-' + priceType"
				label="Index-based Price"
				tooltip-text="In the case of the premium-based indication, the indication price is automatically calculated from the Matif trading month and the selected basis. The basis thus represents the difference between the futures price and the spot price. The update of your listing is delayed by 15 minutes. The following trading months as a guide for wheat: May - Nov (Matif Dec); Dec - Feb (Matif March); Feb - April (Matif May)."
			>
			</ui-radio-group>
		</div>

		<!-- :class="'grid-cols-' + grid.cols" -->
		<div
			v-if="priceType == 'FLAT'"
			class="mt-6 flex flex-wrap gap-x-6 gap-y-4"
			:key="'FLAT_' + priceType"
		>
			<ui-input-group
				:class="inputClass"
				v-model="form.price.mt"
				field="price.mt"
				label="Price"
				suffix="EUR/t"
				:form="form"
				:required="form.trade == 'SELL' || isPriceRequired"
				:dp="2"
			></ui-input-group>
		</div>

		<div
			v-else-if="priceType == 'INDEXED'"
			class="mt-6 flex flex-wrap gap-x-6 gap-y-4"
			:key="'INDEXED_' + priceType"
		>
			<ui-select-group
				:class="inputClass"
				v-model="form.price.commodity_future_id"
				field="price.commodity_future_id"
				type="select"
				label="Future"
				:options="futuresOptions"
				:form="form"
				:required="true"
				:placeholder="false"
			></ui-select-group>
			<ui-input-group
				:class="inputClass"
				v-model="form.price.basis"
				field="price.basis"
				label="Price Basis"
				suffix="EUR/t"
				:form="form"
				:required="true"
				:dp="2"
			></ui-input-group>
		</div>

		<div v-if="priceType !== 'NONE'" class="mt-1 text-gray-500 text-sm">
			{{ __("Prices are net of VAT (value added tax)") }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		isPriceRequired: {
			type: Boolean,
			default: true,
		},
		showLabel: {
			type: Boolean,
			default: true,
		},
		inputClass: {
			type: String,
			default: "basis-full sm:basis-[30.75%]",
		},
	},
	computed: {
		priceType: {
			get() {
				return this.form.price.type;
			},
			set(newValue) {
				this.form.price.type = newValue;

				if (newValue == "INDEXED") {
					this.form.price.mt = null;
				} else if (newValue == "FLAT") {
					this.form.price.basis = null;
					this.form.price.commodity_future_id = null;
				} else if (newValue == "NONE") {
					this.form.price.mt = null;
					this.form.price.basis = null;
					this.form.price.commodity_future_id = null;
				}
			},
		},
		futuresOptions() {
			let tickers = {
					RAPE: "ECO",
					MAIZE: "EMA",
				},
				desiredTicker = tickers[this.form.product.type] || "EBM";
			return (this.activeFutures || [])
				.filter((f) =>
					this.form.product.type == "MAIZE"
						? f.ticker_code == desiredTicker || f.ticker_code == "EBM"
						: f.ticker_code == desiredTicker
				)
				.sort((a, b) =>
					a.ticker_code > b.ticker_code
						? 1
						: b.ticker_code > a.ticker_code
						? -1
						: 0
				);
		},
		indexedPriceTypeIsDisabled() {
			return ["FABA", "PEA"].includes(this.form.product.type);
		},
	},
};
</script>
